
export const CxIconChar = {
    exclamation : '❗',
    pin         : '📍',
    questionMark: '?',
};

export const CxAppIconChar = {
    extensionWeek   : CxIconChar.exclamation,
    extensionDay    : CxIconChar.pin,
    help            : CxIconChar.questionMark
};

export const getAppIconChar = (name, postfix='') => {
    const iconChar = CxAppIconChar[name] || CxAppIconChar['help'];
    return iconChar + postfix
}
